<template src="./Recebimento.html"></template>

<script>
  import { mapMutations } from "vuex";  
  import store from "@/store";
  import moment from "moment";  
  import acordo from "@/services/acordo";
  import juno from "@/services/juno";
  import devedores from "@/services/devedores";
  import usuario from "@/services/usuario";
  import cliente from "@/services/cliente";
  import {json2excel, excel2json} from 'js2excel';

  export default {
    name: 'Endereco',
    data () {
      return {
        valid: true,
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        user: {},
        acordo: {},
        dialogConfirmation:false,
        dialogError: false,
        dialogParcela: false,
        editando: false,
        message: "",
        excluindo: {},
        cep: {},
        devedor: {},
        filtros: {},
        parcelas: [],
        funcionarios: [],
        clientes: [],
        headersParcelas: [{
            text: 'Numero',
            value: 'numero'
          },
          {
            text: 'Vencimento',
            value: 'vencimento'
          },
          {
            text: 'Valor',
            value: 'valor'
          },
          {
            text: 'Data Pagamento',
            value: 'dtPagamento'
          }
        ]
      }
    },
    computed: {
      headersParcela () { 
        
        let items = [];
        if (store.getters.user) {
          
          if (this.user.acesso == "Cliente") {
            items = [
              {
                text: 'Nome Devedor',
                align: 'left',
                sortable: true,
                value: 'acordo.devedor.Nome'
              },
              {
                text: 'CPF Devedor',
                align: 'left',
                sortable: true,
                value: 'acordo.devedor.CnpjCpf'
              },
              {
                text: 'Vencimento',
                align: 'left',
                sortable: true,
                value: 'vencimento'
              },
              {
                text: 'Data Pagamento',
                align: 'left',
                sortable: true,
                value: 'dtPagamento'
              },
              {
                text: 'Status',
                align: 'left',
                sortable: true,
                value: 'status'
              },
              {
                text: 'Nr Parcela',
                align: 'left',
                sortable: true,
                value: 'numero'
              },
              {
                text: 'Valor Bruto',
                align: 'left',
                sortable: true,
                value: 'valor'
              },
              {
                text: 'Forma de Pagamento',
                align: 'left',
                sortable: true,
                value: 'tipoPagamento'
              },
              {
                text: 'Empresa',
                align: 'left',
                sortable: true,
                value: 'acordo.cliente.Nome'
              }
            ];
          } else if (this.user.acesso == "Funcionario") {
            items = [
              {
                text: 'Nome Devedor',
                align: 'left',
                sortable: true,
                value: 'acordo.devedor.Nome'
              },
              {
                text: 'CPF Devedor',
                align: 'left',
                sortable: true,
                value: 'acordo.devedor.CnpjCpf'
              },
              {
                text: 'Vencimento',
                align: 'left',
                sortable: true,
                value: 'vencimento'
              },
              {
                text: 'Data Pagamento',
                align: 'left',
                sortable: true,
                value: 'dtPagamento'
              },
              {
                text: 'Status',
                align: 'left',
                sortable: true,
                value: 'status'
              },
              {
                text: 'Nr Parcela',
                align: 'left',
                sortable: true,
                value: 'numero'
              },
              {
                text: 'Valor Parcela',
                align: 'left',
                sortable: true,
                value: 'valor'
              },
              {
                text: 'Forma de Pagamento',
                align: 'left',
                sortable: true,
                value: 'tipoPagamento'
              },
              {
                text: 'Empresa',
                align: 'left',
                sortable: true,
                value: 'acordo.cliente.Nome'
              },
              {
                text: 'Ações',
                value: 'action'
              }
            ];
          
          } else {
            items = [
              {
                text: 'Nome Devedor',
                align: 'left',
                sortable: true,
                value: 'acordo.devedor.Nome'
              },
              {
                text: 'CPF Devedor',
                align: 'left',
                sortable: true,
                value: 'acordo.devedor.CnpjCpf'
              },
              {
                text: 'Vencimento',
                align: 'left',
                sortable: true,
                value: 'vencimento'
              },
              {
                text: 'Data Pagamento',
                align: 'left',
                sortable: true,
                value: 'dtPagamento'
              },
              {
                text: 'Status',
                align: 'left',
                sortable: true,
                value: 'status'
              },
              {
                text: 'Nr Parcela',
                align: 'left',
                sortable: true,
                value: 'numero'
              },
              {
                text: 'Valor Parcela',
                align: 'left',
                sortable: true,
                value: 'valor'
              },
              {
                text: 'Valor Cliente',
                align: 'left',
                sortable: true,
                value: 'cliente'
              },
              {
                text: 'Valor Assoc',
                align: 'left',
                sortable: true,
                value: 'valorAssoc'
              },
              {
                text: 'Valor Juros',
                align: 'left',
                sortable: true,
                value: 'valorJuros'
              },
              {
                text: 'Valor Bruto',
                align: 'left',
                sortable: true,
                value: 'valor'
              },
              {
                text: 'Forma de Pagamento',
                align: 'left',
                sortable: true,
                value: 'tipoPagamento'
              },
              {
                text: 'Forma de Negociação',
                align: 'left',
                sortable: true,
                value: 'tipoNegociacao'
              },
              {
                text: 'Empresa',
                align: 'left',
                sortable: true,
                value: 'acordo.cliente.Nome'
              },
              {
                text: 'Ações',
                value: 'action'
              }
            ];
          }
            
        }
          
        return items;
      }
    },
    async created () {
      let items = [];
      this.setLoading(true);
      this.clientes = await cliente.getClientes();
      this.funcionarios = await usuario.getFuncionarios();
      console.log(this.$route.params.id);
      if (store.getters.user) {
        this.user = await usuario.getUsuario(store.getters.user._id);
        await this.buscarParcelas(this.$route.params.id);
      }
      this.setLoading(false);
    },
    watch: {
      '$route': async function (){
        this.setLoading(true);
        if (store.getters.user) {
          this.user = await usuario.getUsuario(store.getters.user._id);
          await this.buscarParcelas(this.$route.params.id);
        }
        this.setLoading(false);
      }
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async abrirAcordo (acordo) {
        for await (const parcela of acordo.parcelas) {
          parcela.juno = await juno.get(parcela._id);
        }
        this.acordo = acordo;
        this.dialogParcela = true;
      },
      getColorParcela (parcela) {
        if (parcela.dtPagamento) {
          return 'green'
        }
        if (parcela.acordo.StatusAcordo == 9) {
          return 'grey';
        }
        if (moment(parcela.vencimento) < moment().subtract(1, 'days') && (parcela.stPago == 'N')) {
          return 'red';
        }
      },
      async buscarParcelas (status) {
        this.filtros.status = status;
        this.setLoading(true);
        if (this.user != null && this.user.acesso == "Funcionario") {
          this.parcelas = await acordo.getParcelas({funcionario: store.getters.user._id, date: this.date, filtros: this.filtros});
        } else if (this.user != null && this.user.acesso == "Cliente") {
          this.parcelas = await acordo.getParcelas({cliente: this.user.cliente, date: this.date, filtros: this.filtros});
        } else if (this.user != null && (this.user.acesso == "Admin" || this.user.acesso == "Financeiro" || this.user.acesso == "AdminClientes")) {
          this.parcelas = await acordo.getParcelas({date: this.date, filtros: this.filtros});
        }
        this.setLoading(false);
      },
      async gerarBoleto (item) {
        if (!item.juno) {
          let response = await juno.createCharge(item);
          if (response.message) {
            this.message = response.message;
            this.dialogError = true;
          } else if (response.details) {
            this.message = response.details;
            this.dialogError = true;
          } else {
            this.message = "Boleto gerado com sucesso!";
            this.dialogError = true;
            
            this.setDevedor(await devedores.getDevedoreId(this.acordo.devedor));
            this.abrirAcordo (this.acordo);
          }
        } else {
          window.open(item.juno.link,'_blank');
        }
      },
      cobrar: function (item) {
        this.$router.push('/funcionario/cobranca/'+item.acordo.devedor._id);
      },
      async listar (item) {
        this.acordo = item.acordo;
        this.dialogParcela = true;
      },
      buscaValorTotalParcela (acordo) {
        if (acordo.parcelas&&acordo.parcelas.length>0) {
          if (this.user != null && this.user.acesso == "Cliente") {
            return acordo.parcelas.map((item) => {return item.cliente}).reduce((prev, next) => {return (prev + next)});
          } else {
            return acordo.parcelas.map((item) => {return item.valor}).reduce((prev, next) => {return (prev + next)});
          }
        } else {
          return 0;
        }
      },
      totalGravados (parcelas) {
        let retorno = 0;
        if (parcelas&&parcelas.length>0) {
          for (const parcela of parcelas) {
            if (parcela.acordo.StatusAcordo != 9) {
              if (this.user != null && 
                  this.user.acesso == "Cliente") {
                retorno += parcela.cliente;
              } else {
                retorno += parcela.valor;
              }
            }
          }
        } else {
          return 0;
        } 
        return retorno;
      },
      totalVigente (parcelas) {
        let retorno = 0;
        if (parcelas&&parcelas.length>0) {
          for (const parcela of parcelas) {
            if ((parcela.acordo.StatusAcordo != 9) && 
                (moment(parcela.vencimento) > moment().subtract(1, 'days') && 
                (parcela.stPago == 'N'))) {
              if (this.user != null && 
                  this.user.acesso == "Cliente") {
                retorno += parcela.cliente;
              } else {
                retorno += parcela.valor;
              }
            }
          }
        } else {
          return 0;
        } 
        return retorno;
      },
      buscaReceita (parcelas) {
        let retorno = 0;
        for (const parcela of parcelas) {
          if (this.user != null && 
              this.user.acesso == "Cliente" && 
              (parcela.stPago == 'S')) {
            retorno = retorno + (parcela.cliente);
          } else {
            if (parcela.cliente && (parcela.stPago == 'S')) {
              retorno = retorno + (parcela.valor - parcela.cliente -(parcela.valorAssoc?parcela.valorAssoc:0)-(parcela.valorJuros?parcela.valorJuros:0));
            }
          }
        }
        return retorno;
      },
      buscaRecebido (parcelas) {
        let retorno = 0;
        for (const parcela of parcelas) {
          if (parcela.stPago == 'S') {
            if (this.user != null && this.user.acesso == "Cliente" && parcela.cliente) {
              retorno = retorno + (parcela.cliente);
            } else {
              retorno = retorno + (parcela.valor);
            }
          }
        }
        return retorno;
      },
      buscaAtraso (parcelas) {
        let retorno = 0;
        for (const parcela of parcelas) {
          if (parcela.acordo.StatusAcordo != 9) {
            if (moment(parcela.vencimento) < moment().subtract(1, 'days') && 
                (parcela.stPago == 'N')) {
              if (this.user != null && this.user.acesso == "Cliente") {
                retorno = retorno + (parcela.cliente);
              } else {
                retorno = retorno + (parcela.valor); 
              }
            }
          }
        }
        return retorno;
      },
      buscaCancelados (parcelas) {
        let retorno = 0;
        for (const parcela of parcelas) {
          if (parcela.acordo.StatusAcordo == 9 && parcela.stPago != 'S') {
            if (this.user != null && this.user.acesso == "Cliente") {
              retorno = retorno + (parcela.cliente);
            } else {
              retorno = retorno + (parcela.valor); 
            }
          }
        }
        return retorno;
      },
      getStatusAcordo (item) {
        if (item.acordo.StatusAcordo == 9) {
          return 'Acordo Cancelado';
        }
        if (moment(item.vencimento) < moment().subtract(1, 'days') && (item.stPago == 'N')) {
          return 'Acordo em Atraso';
        }
        if (item.acordo.StatusAcordo == 1) {
          return 'Processo Cobrança';
        } else if (item.acordo.StatusAcordo == 2) {
          return 'Aguardando Aprovação';
        } else if (item.acordo.StatusAcordo == 3) {
          return 'Acordo Vigente';
        } else if (item.acordo.StatusAcordo == 6) {
          return 'Acordo Liquidado';
        }
      },
      getProposta (proposta) {
        if (proposta == 1) {
          return 'Fixa';
        } else if (proposta == 2) {
          return 'Exceção';
        } else if (proposta == 3) {
          return 'Gerado Devedor';
        }
      },
      getStPago (item) {
        if (!item.juno) {
          return 'Boleto não Gerado';
        }
        if (item.juno.payments && item.juno.payments.length > 0) {
          return 'Pago';
        }
        if (moment(item.juno.dueDate) < moment()) {
          return 'Atraso';
        }
        if (item.stPago == 'N') {
          return 'Não Pago';
        } 
      },
      getPagamento (pagamento) {
        if (pagamento == 1) {
          return 'Boleto';
        } else if (pagamento == 2) {
          return 'Deposito';
        } else if (pagamento == 3) {
          return 'Escritório';
        } else if (pagamento == 4) {
          return 'Na Loja';
        } else if (pagamento == 5) {
          return 'Pix';
        }
      },
      getNegociacao (pagamento) {
        if (pagamento == 1) {
          return 'Acordo Novo';
        } else if (pagamento == 2) {
          return 'Reativação';
        } else if (pagamento == 3) {
          return 'Renegociação';
        }
      },
      buscaMeta (user, valor) {
        if (user.meta3 && user.meta3 && user.meta3) {
          
          if (valor > user.meta2) {
            return "3ª " + ((valor/user.meta3)*100).toFixed(2) + "%";
          } else if (valor > user.meta1) {
            return "2ª " + ((valor/user.meta2)*100).toFixed(2) + "%";
          } else {
            return "1ª " + ((valor/user.meta1)*100).toFixed(2) + "%";
          }
        } else {
          return "Não Cadastrado."
        }
      },
      buscaMetaCor (user, valor) {
        if (user.meta3 && user.meta3 && user.meta3) {
          if (valor > user.meta2) {
            return "green";
          } else if (valor > user.meta1) {
            return "blue";
          } else {
            return "grey";
          }
        } else {
          return "white"
        }
      },
      exportarExcel (parcelas) {
        let data = [];
        parcelas.forEach(parcela => {

          let object = {};
          if (this.user.acesso == "Cliente") {
            object = {
              "Empresa": parcela.acordo.cliente.Nome,
              "Funcionario": parcela.acordo.user.name,
              "Devedor": parcela.acordo.devedor.Nome,
              "Vencimento": moment(parcela.vencimento).format("DD/MM/YYYY"),
              "CPF": parcela.acordo.devedor.CnpjCpf,
              "Telefone": parcela.acordo.devedor.TelefonePrincipal,
              "Status Divida": this.getStatusAcordo(parcela),
              //"Valor Parcela": this.formatPrice(parcela.valor),
              "Pagamento": moment(parcela.dtPagamento).format("DD/MM/YYYY"),
              "Parcela": parcela.numero+'/'+parcela.acordo.parcelas.length,
              "Valor Bruto": this.formatPrice(parcela.cliente),
              "Forma Pagamento": this.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
            }
          } else {
            object = {
              "Empresa": parcela.acordo.cliente.Nome,
              "Funcionario": parcela.acordo.user.name,
              "Devedor": parcela.acordo.devedor.Nome,
              "Vencimento": moment(parcela.vencimento).format("DD/MM/YYYY"),
              "CPF": parcela.acordo.devedor.CnpjCpf,
              "Telefone": parcela.acordo.devedor.TelefonePrincipal,
              "Status Divida": this.getStatusAcordo(parcela),
              "Pagamento": moment(parcela.dtPagamento).format("DD/MM/YYYY"),
              "Parcela": parcela.numero+'/'+parcela.acordo.parcelas.length,
              "Valor Parcela": this.formatPrice(parcela.valor),
              "Valor Bruto": this.formatPrice(parcela.valor-parcela.cliente-(parcela.valorAssoc?parcela.valorAssoc:0)-(parcela.valorJuros?parcela.valorJuros:0)),
              "Valor Cliente": this.formatPrice(parcela.cliente),
              "Valor Assoc": this.formatPrice(parcela.valorAssoc),
              "Valor Juros": this.formatPrice(parcela.valorJuros),
              "Forma Pagamento": this.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
            }
          }
          
          data.push(object);
        });
        try {
            json2excel({
                data,
                name: 'parcelas',
                formateDate: 'dd/mm/yyyy'
            });
        } catch (e) {
            console.error('export error');
        }
      },
      ...mapMutations({
        setLoading : "setLoading",
        setDevedor: "setDevedor",
      })
    }
  }
</script>

<style scoped>
  .v-data-table {
    margin-top: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/recebimento/Recebimento.vue